// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3zrRo","buttons":"Footer_buttons__2Nn5U"};